module.exports = __webpack_public_path__ + "static/media/bn.82577bde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bn.svg
// module id = 69
// module chunks = 0